import React, { FC, useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  TextField,
  Pivot,
  PivotLinkSize,
  PivotItem,
  IPivotStyles,
  IStyleSet,
  Text,
  mergeStyleSets,
  MessageBar,
  MessageBarType,
  PivotLinkFormat,
  Dropdown,
  IDropdownOption,
  registerIcons,
  Panel,
  PanelType,
  DefaultButton,
  Stack,
  IStackStyles,
  IStackProps,
  PrimaryButton,
  Checkbox,
} from "@fluentui/react";
import ApiSpinner from "../../common/ApiSpinner";
import { TruckNomination } from "../../../models";
import "../../nominations/NominationList.css";
import * as LineHandlingStore from "../../../store/LineHandlingStore";
import * as SofViewStore from "../../../store/SofViewStore";
import * as SelectedTabStore from "../../../store/SelectedTabDataStore";
import * as ProcessFlowConfigStore from "../../../store/ProcessFlowConfigStore";
import * as GeneralStore from "../../../store/GeneralStore";
import { State } from "../../../store";
import clsx from "clsx";
import { PersistentDataService } from "../../../services/PersistentDataService";
import { pushNotification } from "../../../api/pushNotification";
import { FontIcon } from "@fluentui/react/lib/Icon";
import NominationItem from "./NominationItem2";
import { useBoolean } from "@uifabric/react-hooks";
import SofIcon from "../../common/Icons";
import FileUpload from "../common/FIleUpload";
import { NominationApi } from "../../../api/nominationApi";
import { useHistory } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import QRScanner from "../QRScanner";

type Props = SelectedTabStore.SelectedTabState &
  SofViewStore.SofViewState &
  GeneralStore.GeneralState &
  typeof LineHandlingStore.actionCreators &
  typeof ProcessFlowConfigStore.actionCreators &
  typeof SelectedTabStore.actionCreators &
  typeof SofViewStore.actionCreators &
  typeof GeneralStore.actionCreators;

const pageSize = 20;
const classes = mergeStyleSets({
  tab: {
    // borderBottom: "1px solid #E2E6E8",
  },
  mainDiv: {
    overflow: "hidden",
    height: "100%",
  },
  pivotItem: {
    display: "inline-block",
    marginLeft: "10px",
  },
  mainList: {
    overflowX: "hidden",
    overflowY: "scroll",
    maxHeight: "calc(100vh - 254px)",
    padding: "0",
    marginRight: "1px",
  },
  searcheBoxDiv: {
    position: "absolute",
    top: "5px",
    right: "5px",
    width: "25%",
  },
  dropDownDiv: {
    position: "absolute",
    top: "5px",
    right: "26%",
    width: "8%",
  },
  oval: {
    minwidth: "50px",
    minheight: "50px",
    background: "#4CAF50",
    borderRadius: "50%",
    fontSize: "small",
    padding: "1px 6px 2px 6px",
    color: "#FFF",
  },
  filterButton: {
    background: "#EDEDED",
    border: "none",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "0 12px 0 12px",
    gap: "6px",
    color: "#4C4C4C",
    fontSize: "14px",
    fontWeight: "700",
    selectors: {
      ":focus": {
        outline: "none",
      },
    },
  },
  blackButton: {
    background: "#262626 !important",
    color: "#FAFAFA !important",
    height: "42px",
    borderRadius: "8px",
  },
  viewIcon: {
    color: "#4C4C4C",
    margin: "auto",
    display: "block",
  },
  viewButton: {
    width: "40px",
    height: "40px",
    borderRadius: "5px",
    border: "1px solid #E2E6E8",
    backgroundColor: "#FAFAFA",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    selectors: {
      ":hover": {
        backgroundColor: "#EEEEEE",
        textDecoration: "none",
      },
    },
  },
});

registerIcons({
  icons: {
    "custom-search-svg": (
      <svg
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.5 12.5C7.83123 12.4997 9.1241 12.0541 10.1728 11.234L13.4697 14.531L14.5303 13.4705L11.2333 10.1735C12.0538 9.12475 12.4997 7.83158 12.5 6.5C12.5 3.19175 9.80825 0.5 6.5 0.5C3.19175 0.5 0.5 3.19175 0.5 6.5C0.5 9.80825 3.19175 12.5 6.5 12.5ZM6.5 2C8.98175 2 11 4.01825 11 6.5C11 8.98175 8.98175 11 6.5 11C4.01825 11 2 8.98175 2 6.5C2 4.01825 4.01825 2 6.5 2Z"
          fill="#4C4C4C"
        />
      </svg>
    ),
  },
});

// const pivotStyles: Partial<IStyleSet<IPivotStyles>> = {
//   link: {
//     minWidth: "120px",
//     fontSize: "14px",
//     fontWeight: 400,
//     borderRadius: "1000px",
//     selectors: {
//       ":hover": {
//         backgroundColor: "var(--grey-050)",
//         color: "var(--grey-800)",
//         borderRadius: "1000px",
//       },
//       ":active": {
//         backgroundColor: "var(--grey-050)",
//         color: "var(--grey-800)",
//       },
//     },
//   },
//   linkIsSelected: {
//     minWidth: "150px",
//     backgroundColor: "var(--grey-050)",
//     borderRadius: "1000px",
//     color: "var(--grey-800)",
//     fontWeight: 700,
//     fontSize: "14px",
//     selectors: {
//       ":hover": {
//         backgroundColor: "var(--grey-050)",
//         color: "var(--grey-800)",
//       },
//       ":active": {
//         backgroundColor: "var(--grey-050)",
//         color: "var(--grey-800)",
//       },
//     },
//   },
// };

const stackStyles: Partial<IStackStyles> = {
  root: { width: "100%", display: " flex", marginTop: "20px", gap: "6px" },
};

const NominationListPage: FC<Props> = (props: Props) => {
  // const [lineHHandlings, setLineHandlings] = useState<LineHandling[]>([]);
  const [nominations, setNominations] = useState<TruckNomination[]>([]);
  const [modality, setModality] = useState(0);
  const [modalityName, setModalityName] = useState("marine");
  const [nextPage, setNextPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [isEndReached, setIsEndReached] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>();
  const [keyword, setKeyword] = useState<string>();
  const [newExpected, setNewExpected] = useState<"0">();
  const [newHalted, setNewHalted] = useState<"0">();
  const [newArrived, setNewArrived] = useState<"0">();
  const [newReleased, setNewReleased] = useState<"0">();
  const [newRejected, setNewRejected] = useState<"0">();
  const [salesOrg, setSalesOrg] = useState<string>();
  const [selectedNomination, setSelectedNomination] = useState<string>();
  const [showQRModal, setShowQRModal] = useState<boolean>(false);
  const [isOpen, { setTrue: openPanel, setFalse: dismissPanel }] =
    useBoolean(false);

  const [
    isOpenAttachment,
    { setTrue: openAttachmentPanel, setFalse: dismissAttachmentPanel },
  ] = useBoolean(false);
  const history = useHistory();

  const options: IDropdownOption[] = [
    { key: "ALL", text: "ALL" },
    { key: "PHL", text: "PHL" },
    { key: "USA", text: "USA" },
  ];

  const removeScrolling = () => {
    const main = document.getElementById("div-nomination-list");
    if (main) {
      main.removeEventListener("scroll", trackScrolling);
    }
  };

  const trackScrolling = async () => {
    const main = document.getElementById("main-scroll");
    if (main) {
      const isBottom =
        main.getBoundingClientRect().bottom <= window.innerHeight;
      if (isBottom) {
        removeScrolling();
        setNextPage((prev) => prev + 1);
      }
    }
  };

  const loadItemsAsync = async (pageNo: number, searchString: string) => {
    try {
      if (pageNo === 1) {
        setNominations([]);
      }
      setErrorMessage(undefined);
      setIsLoading(true);
      let typeOfModality =
        history.location.pathname.indexOf("truck") > 0
          ? 1
          : history.location.pathname.indexOf("rail")
          ? 2
          : 0;
      const result = await NominationApi.getNominationListAsync(
        typeOfModality,
        props.selectedTab,
        getSalesOrg(),
        pageNo,
        pageSize,
        searchString
      );

      setIsLoading(false);
      // setNominations(sampleNominations);
      setNominations(
        pageNo === 1 ? result.results : [...nominations, ...result.results]
      );
      var newCount = JSON.parse(result.optionalProperties);
      setNewExpected(newCount.newExpectedCount);
      setNewHalted(newCount.newHaltedCount);
      setNewArrived(newCount.newArrivedCount);
      setNewReleased(newCount.newReleasedCount);
      setNewRejected(newCount.newRejectedCount);

      const hasMorePages = Math.ceil(result.totalResults / pageSize) > pageNo;
      setIsEndReached(!hasMorePages);
      if (hasMorePages) {
        const wrappedElement = document.getElementById("div-nomination-list");
        if (wrappedElement)
          wrappedElement.addEventListener("scroll", trackScrolling);
      } else {
        removeScrolling();
      }
    } catch (err) {
      const offlineResult = await PersistentDataService.getOfflineNomination(
        props.selectedTab
      );
      setNominations(offlineResult);
      setIsEndReached(true);
      setIsLoading(false);
    }
  };

  const searchAsync = async () => {
    if (keyword !== undefined && (keyword.length > 2 || keyword.length === 0)) {
      await loadItemsAsync(1, keyword);
    }
  };

  const getSalesOrg = () => {
    if (salesOrg) {
      return salesOrg;
    } else {
      return props.marineSalesOrg;
    }
  };

  const iconProps = { iconName: "custom-search-svg" };

  useEffect(() => {
    const timeoutId = setTimeout(() => searchAsync(), 1000);

    return () => clearTimeout(timeoutId);
  }, [keyword]);

  useEffect(() => {
    if (getSalesOrg()) {
      loadItemsAsync(nextPage, keyword === undefined ? "" : keyword);
    }
  }, [nextPage]);

  useEffect(() => {
    if (getSalesOrg()) {
      setNextPage(1);
      setNominations([]);
      loadItemsAsync(nextPage, keyword === undefined ? "" : keyword);
    }
  }, [props.selectedTab, props.marineSalesOrg, salesOrg]);

  useEffect(() => {
    props.getAllConfigs();
    props.deleteActiveLineHandling();
    props.deleteActiveNomination();
    props.deleteActiveConfig();
    return removeScrolling;
  }, []);

  useEffect(() => {
    if (window.location.pathname.indexOf("truck") > 0) {
      setModality(1);
      setModalityName("truck");
      //props.setPageTitle("Truck Nomination");
    } else if (window.location.pathname.indexOf("rail") > 0) {
      setModality(2);
      setModalityName("rail");
      //props.setPageTitle("Rail Nomination");
    }
  }, []);

  // useEffect(() => {
  //   pushNotification.connection.off("ActivityUpdated");

  //   pushNotification.connection.on("ActivityUpdated", (message) => {
  //     var result = message as LineHandling;
  //     var lineHandlingNo = result.lineHandlingNo.toUpperCase();
  //     var lineHandlingList = lineHandlings;
  //     var lineHandling = lineHandlingList.find(
  //       (l) => l.lineHandlingNo.toUpperCase() === lineHandlingNo
  //     );
  //     var cnt = 0;
  //     if (lineHandling !== undefined && cnt === 0) {
  //       lineHandlingList.forEach((lineHandlingItem) => {
  //         if (
  //           lineHandlingItem.lineHandlingNo.toUpperCase() === lineHandlingNo
  //         ) {
  //           lineHandlingItem.progress = result.progress;
  //           lineHandlingItem.nominations.forEach((nominationItem) => {
  //             var nomination = result.nominations.find(
  //               (n) =>
  //                 n.nominationNo.toUpperCase() ===
  //                 nominationItem.nominationNo.toUpperCase()
  //             );

  //             if (nomination !== undefined) {
  //               nominationItem.currentStep = nomination.currentStep;
  //               nominationItem.progress = nomination.progress;
  //               nominationItem.lastActivityDateString =
  //                 nomination.lastActivityDateString;
  //             }
  //           });
  //         }
  //       });

  //       cnt += 1;
  //       setLineHandlings([]);
  //       setLineHandlings(lineHandlingList);
  //     }
  //   });
  // }, [lineHandlings]);

  const capitalizeFirstLetter = (text: string) => {
    return text.charAt(0).toUpperCase() + text.slice(1);
  };

  return (
    <>
      {/* qr scanner modal */}
      {showQRModal && (
        <QRScanner
          classes={classes}
          showQRModal={showQRModal}
          setShowQRModal={setShowQRModal}
        />
      )}

      <div className={classes.mainDiv}>
        <div
          className="ms-Grid"
          dir="ltr"
          style={{ backgroundColor: "white", margin: "12px", padding: "0px" }}
        >
          <div className="ms-Grid-row" style={{ padding: "10px 20px" }}>
            <div className="ms-Grid-col ms-md4">
              <div style={{ fontSize: 24, lineHeight: "48px" }}>
                {capitalizeFirstLetter(modalityName)} Nominations
              </div>
            </div>
            <div className="ms-Grid-col ms-md2"></div>
            <div
              className="ms-Grid-col ms-md6"
              style={{
                display: "flex",
                justifyContent: "flex-end",
                columnGap: 5,
              }}
            >
              <div
                style={{
                  width: 120,
                  color: props.selectedTab === "Expected" ? '#FFF':'#000',
                  padding: "12px 16px",
                  textAlign: "center",
                  background:
                    props.selectedTab === "Expected" ? "#0F7F79" : "#fff",
                  borderColor:
                    props.selectedTab === "Expected" ? "#0F7F79" : "#fff",
                  borderWidth: 0.5,
                  borderRadius: 4,
                  cursor:
                    props.selectedTab === "Expected" ? "default" : "pointer",
                }}
                onClick={() => props.setSelectedTab("Expected", modalityName)}
              >
                Expected
              </div>
              <div
                style={{
                  width: 120,
                  color: props.selectedTab === "Arrived" ? '#FFF':'#000',
                  padding: "12px 16px",
                  textAlign: "center",
                  background:
                    props.selectedTab === "Arrived" ? "#0F7F79" : "#fff",
                  borderColor:
                    props.selectedTab === "Arrived" ? "#0F7F79" : "#fff",
                  borderWidth: 0.5,
                  borderRadius: 4,
                  cursor:
                    props.selectedTab === "Arrived" ? "default" : "pointer",
                }}
                onClick={() => props.setSelectedTab("Arrived", modalityName)}
              >
                Arrived
              </div>
              <div
                style={{
                  width: 120,
                  color: props.selectedTab === "Halted" ? '#FFF':'#000',
                  padding: "12px 16px",
                  textAlign: "center",
                  background:
                    props.selectedTab === "Halted" ? "#0F7F79" : "#fff",
                  borderColor:
                    props.selectedTab === "Halted" ? "#0F7F79" : "#fff",
                  borderWidth: 0.5,
                  borderRadius: 4,
                  cursor:
                    props.selectedTab === "Halted" ? "default" : "pointer",
                }}
                onClick={() => props.setSelectedTab("Halted", modalityName)}
              >
                Halted
              </div>
              <div
                style={{
                  width: 120,
                  color: props.selectedTab === (modality === 2 ? "Repair" : "Rejected") ? '#FFF':'#000',
                  padding: "12px 16px",
                  textAlign: "center",
                  background:
                    props.selectedTab === (modality === 2 ? "Repair" : "Rejected") ? "#0F7F79" : "#fff",
                  borderColor:
                    props.selectedTab === (modality === 2 ? "Repair" : "Rejected") ? "#0F7F79" : "#fff",
                  borderWidth: 0.5,
                  borderRadius: 4,
                  cursor:
                    props.selectedTab === (modality === 2 ? "Repair" : "Rejected") ? "default" : "pointer",
                }}
                onClick={() => props.setSelectedTab(modality === 2 ? "Repair" : "Rejected", modalityName)}
              >
                 {modality === 2 ? "Repair" : "Rejected"}
              </div>
              <div
                style={{
                  width: 120,
                  color: props.selectedTab === "Released" ? '#FFF':'#000',
                  padding: "12px 16px",
                  textAlign: "center",
                  background:
                    props.selectedTab === "Released" ? "#0F7F79" : "#fff",
                  borderColor:
                    props.selectedTab === "Released" ? "#0F7F79" : "#fff",
                  borderWidth: 0.5,
                  borderRadius: 4,
                  cursor:
                    props.selectedTab === "Released" ? "default" : "pointer",
                }}
                onClick={() => props.setSelectedTab("Released", modalityName)}
              >
                Released
              </div>
              {/*<Pivot*/}
              {/*  getTabId={(key: string, index: number) =>*/}
              {/*    `tab-${key.toLowerCase()}`*/}
              {/*  }*/}
              {/*  linkFormat={PivotLinkFormat.tabs}*/}
              {/*  styles={pivotStyles}*/}
              {/*  className={classes.tab}*/}
              {/*  linkSize={PivotLinkSize.large}*/}
              {/*  selectedKey={props.selectedTab}*/}
              {/*  onLinkClick={(item?: PivotItem | undefined) =>*/}
              {/*    item &&*/}
              {/*    item.props.headerText &&*/}
              {/*    props.setSelectedTab(item.props.headerText)*/}
              {/*  }*/}
              {/*>*/}
              {/*  <PivotItem*/}
              {/*    key="Expected"*/}
              {/*    itemKey="Expected"*/}
              {/*    headerText="Expected"*/}
              {/*    onRenderItemLink={() => (*/}
              {/*      <div style={{ width: "100%" }}>*/}
              {/*        <span>Expected</span>*/}
              {/*        {!isLoading &&*/}
              {/*          newExpected != "0" &&*/}
              {/*          newExpected !== undefined && (*/}
              {/*            <span className={classes.pivotItem}>*/}
              {/*              <span className={classes.oval}>{newExpected}</span>*/}
              {/*            </span>*/}
              {/*          )}*/}
              {/*      </div>*/}
              {/*    )}*/}
              {/*    headerButtonProps={{*/}
              {/*      disabled: isLoading,*/}
              {/*    }}*/}
              {/*  />*/}

              {/*  <PivotItem*/}
              {/*    key="Arrived"*/}
              {/*    itemKey="Arrived"*/}
              {/*    headerText="Arrived"*/}
              {/*    onRenderItemLink={() => (*/}
              {/*      <div style={{ width: "100%" }}>*/}
              {/*        <span>Arrived</span>*/}
              {/*        {!isLoading &&*/}
              {/*          newArrived != "0" &&*/}
              {/*          newArrived !== undefined && (*/}
              {/*            <span className={classes.pivotItem}>*/}
              {/*              <span className={classes.oval}>{newArrived}</span>*/}
              {/*            </span>*/}
              {/*          )}*/}
              {/*      </div>*/}
              {/*    )}*/}
              {/*    headerButtonProps={{*/}
              {/*      disabled: isLoading,*/}
              {/*    }}*/}
              {/*  />*/}

              {/*  <PivotItem*/}
              {/*    key={"Halted"}*/}
              {/*    itemKey={"Halted"}*/}
              {/*    headerText={"Halted"}*/}
              {/*    onRenderItemLink={() => (*/}
              {/*      <div style={{ width: "100%" }}>*/}
              {/*        <span>Halted</span>*/}
              {/*        {!isLoading &&*/}
              {/*          newHalted != "0" &&*/}
              {/*          newHalted !== undefined && (*/}
              {/*            <span className={classes.pivotItem}>*/}
              {/*              <span className={classes.oval}>{newHalted}</span>*/}
              {/*            </span>*/}
              {/*          )}*/}
              {/*      </div>*/}
              {/*    )}*/}
              {/*    headerButtonProps={{*/}
              {/*      disabled: isLoading,*/}
              {/*    }}*/}
              {/*  />*/}

              {/*  {modality === 2 && (*/}
              {/*    <PivotItem*/}
              {/*      key={"Repair"}*/}
              {/*      itemKey={"Repair"}*/}
              {/*      headerText={"Repair"}*/}
              {/*      onRenderItemLink={() => (*/}
              {/*        <div style={{ width: "100%" }}>*/}
              {/*          <span>Repair</span>*/}
              {/*          */}
              {/* {!isLoading && (*/}
              {/*
               */}
              {/*            <span className={classes.pivotItem}>*/}
              {/*
               */}
              {/*              <span className={classes.oval}></span>*/}
              {/*
               */}
              {/*            </span>*/}
              {/*
               */}
              {/*          )} */}
              {/*        </div>*/}
              {/*      )}*/}
              {/*      headerButtonProps={{*/}
              {/*        disabled: isLoading*/}
              {/*      }}*/}
              {/*    />*/}
              {/*  )}*/}

              {/*  {*/}
              {/*      modality === 1*/}
              {/*      &&*/}
              {/*      <PivotItem*/}
              {/*          key={modality === 1 ? "Rejected" : "Retain/Hold"}*/}
              {/*          itemKey={modality === 1 ? "Rejected" : "Retain/Hold"}*/}
              {/*          headerText={modality === 1 ? "Rejected" : "Retain/Hold"}*/}
              {/*          onRenderItemLink={() => (*/}
              {/*              <div style={{ width: "100%" }}>*/}
              {/*                  <span>{modality === 1 ? "Rejected" : "Retain/Hold"}</span>*/}
              {/*                  {!isLoading &&*/}
              {/*                      newRejected != "0" &&*/}
              {/*                      newRejected !== undefined && (*/}
              {/*                          <span className={classes.pivotItem}>*/}
              {/*                              <span className={classes.oval}>{newRejected}</span>*/}
              {/*                          </span>*/}
              {/*                      )}*/}
              {/*              </div>*/}
              {/*          )}*/}
              {/*          headerButtonProps={{*/}
              {/*              disabled: isLoading*/}
              {/*          }}*/}
              {/*      />*/}
              {/*  }*/}

              {/*  <PivotItem*/}
              {/*    key="Released"*/}
              {/*    itemKey="Released"*/}
              {/*    headerText="Released"*/}
              {/*    onRenderItemLink={() => (*/}
              {/*      <div style={{ width: "100%" }}>*/}
              {/*        <span>Released</span>*/}
              {/*        {!isLoading &&*/}
              {/*          newReleased != "0" &&*/}
              {/*          newReleased !== undefined && (*/}
              {/*            <span className={classes.pivotItem}>*/}
              {/*              <span className={classes.oval}>{newReleased}</span>*/}
              {/*            </span>*/}
              {/*          )}*/}
              {/*      </div>*/}
              {/*    )}*/}
              {/*    headerButtonProps={{*/}
              {/*      disabled: isLoading,*/}
              {/*    }}*/}
              {/*  />*/}
              {/*</Pivot>*/}
            </div>
          </div>
          <div className="ms-Grid-row" style={{ padding: "2px 20px" }}>
            <div className="ms-Grid-col ms-md6">
              <div style={{ maxWidth: 400 }}>
                <TextField
                  id="txt-search"
                  placeholder="Search by keyword"
                  iconProps={iconProps}
                  disabled={isLoading}
                  onChange={(e, newValue?: string | undefined) =>
                    setKeyword(newValue === undefined ? "" : newValue)
                  }
                  styles={{
                    fieldGroup: { height: "42px", border: "1px solid #D8DFE6" },
                    icon: {
                      lineHeight: "36px",
                      height: "40px",
                      width: "39px",
                      textAlign: "center",
                      background: "#EDEDED",
                      bottom: "0",
                      right: "0",
                      color: "#4C4C4C",
                    },
                  }}
                />
              </div>
            </div>
            {modality === 2 && (
              <div className="ms-Grid-col ms-md6">
                <div
                  className="ms-Grid-col ms-md6"
                  style={{ float: "right", maxWidth: "153px" }}
                >
                  <Button
                    className={classes.blackButton}
                    style={{ width: "100%" }}
                    onClick={() => setShowQRModal(!showQRModal)}
                  >
                    Scan QR Code
                  </Button>
                </div>
              </div>
            )}

            {/* <div className="ms-Grid-col ms-md6">
                          <div style={{ maxWidth: 100, float: "right" } }>
                          <Dropdown
                              options={options}
                              defaultSelectedKey={getSalesOrg()}
                              disabled={props.marineSalesOrg !== "ALL" || isLoading}
                              onChange={(e, selectedOption) => {
                                  setSalesOrg(selectedOption!.text);
                              }}
                              className="searchDropdown"
                          />
                          </div>
                    </div> */}
          </div>
          {/*<div*/}
          {/*  className="ms-Grid-row"*/}
          {/*  style={{*/}
          {/*    padding: "20px 12px",*/}
          {/*    fontWeight: "bold",*/}
          {/*    borderBottom: "1px solid #E2E6E8",*/}
          {/*    borderTop: "1px solid #E2E6E8",*/}
          {/*    margin: 0,*/}
          {/*    color: "#7C7777",*/}
          {/*  }}*/}
          {/*>*/}
          {/*  {history.location.pathname.indexOf("truck") > 0 && (*/}
          {/*    <>*/}
          {/*      <div className="ms-Grid-col ms-md2 ms-lg2">Tank</div>*/}
          {/*      <div className="ms-Grid-col ms-md1 ms-lg1">*/}
          {/*        Customer Order #*/}
          {/*      </div>*/}
          {/*      <div className="ms-Grid-col ms-md1 ms-lg1">Loading Spot</div>*/}
          {/*    </>*/}
          {/*  )}*/}
          {/*  {history.location.pathname.indexOf("rail") > 0 && (*/}
          {/*    <>*/}
          {/*      <div className="ms-Grid-col ms-md2 ms-lg1">Tank</div>*/}
          {/*      <div className="ms-Grid-col ms-md1 ms-lg1">Rail Car #</div>*/}
          {/*      <div className="ms-Grid-col ms-md1 ms-lg1">Loading Rack</div>*/}
          {/*    </>*/}
          {/*  )}*/}
          {/*  <div*/}
          {/*    className={`ms-Grid-col ms-md1 ms-lg${*/}
          {/*      modality === 1 ? "1" : "2"*/}
          {/*    }`}*/}
          {/*  >*/}
          {/*    Nomination #*/}
          {/*  </div>*/}
          {/*  <div className="ms-Grid-col ms-md2 ms-lg2">Assigned To</div>*/}
          {/*  */}
          {/*{!(modality === 2 && props.selectedTab === "Expected") && }*/}
          {/*  <div className="ms-Grid-col ms-md2 ms-lg2">*/}
          {/*    {props.selectedTab === "Expected" && "Scheduled Time"}*/}
          {/*    {props.selectedTab === "Arrived" && "Arrival Date"}*/}
          {/*    {props.selectedTab === "Halted" && "Paused Date"}*/}
          {/*    {props.selectedTab === "Rejected" && "Rejected Date"}*/}
          {/*    {props.selectedTab === "Released" && "Released Date"}*/}
          {/*  </div>*/}
          {/*  <div*/}
          {/*    className="ms-Grid-col ms-md1 ms-lg1 progress-item"*/}
          {/*    style={{ paddingLeft: "40px" }}*/}
          {/*  >*/}
          {/*    Progress*/}
          {/*  </div>*/}
          {/*  <div className="ms-Grid-col ms-md2 ms-lg2"></div>*/}
          {/*</div>*/}
          <div
            id="div-nomination-list"
            className={clsx(classes.mainList, "custom-scroll")}
          >
            <div id="main-scroll" dir="ltr">
              {errorMessage && (
                <MessageBar messageBarType={MessageBarType.error}>
                  {errorMessage}{" "}
                  <a
                    onClick={() =>
                      loadItemsAsync(
                        nextPage,
                        keyword === undefined ? "" : keyword
                      )
                    }
                  >
                    Click here to retry.
                  </a>
                </MessageBar>
              )}

              {nominations.map((nomination: TruckNomination, index: number) => (
                <NominationItem
                  key={`nomination-${index}`}
                  nomination={nomination}
                  modality={modality}
                  onEtaUpdated={(nomination) =>
                    setNominations([
                      ...nominations.slice(0, index),
                      nomination,
                      ...nominations.slice(index + 1),
                    ])
                  }
                  openAttachmentPanel={openAttachmentPanel}
                  setSelectedNomination={setSelectedNomination}
                  selectedTab={props.selectedTab}
                />
              ))}

              {isEndReached && !isLoading && (
                <div className="ms-Grid-row">
                  <div className="ms-Grid-col ms-md12">
                    <Text
                      variant="small"
                      block
                      style={{ textAlign: "center", color: "#c4c4c4" }}
                    >
                      - End of list -
                    </Text>
                  </div>
                </div>
              )}
              {isLoading && <ApiSpinner />}
            </div>
          </div>
        </div>
      </div>
      <Panel
        className="panel-filter"
        isOpen={isOpen}
        onDismiss={dismissPanel}
        type={PanelType.smallFixedFar}
        closeButtonAriaLabel="Close"
        headerText="Filter Nominations"
      >
        <Stack horizontal styles={stackStyles}>
          <div style={{ width: "100%" }}>
            <Dropdown
              label="Terminal"
              options={options}
              defaultSelectedKey={getSalesOrg()}
              disabled={props.marineSalesOrg !== "ALL" || isLoading}
              onChange={(e, selectedOption) => {
                setSalesOrg(selectedOption!.text);
              }}
              style={{ borderRadius: 0 }}
            />
          </div>
        </Stack>
        <Stack horizontal styles={stackStyles}>
          <div style={{ width: "100%" }}>
            <Dropdown label="Truck Loading Spot" options={options} />
          </div>
        </Stack>
        <Stack horizontal styles={stackStyles}>
          <div style={{ width: "100%" }}>
            <PrimaryButton
              style={{ width: "100%" }}
              text="Apply Filter"
              allowDisabledFocus
            />
          </div>
          <div style={{ width: "100%" }}>
            <DefaultButton
              style={{ width: "100%" }}
              text="Clear All"
              allowDisabledFocus
            />
          </div>
          {/* <div>
            <Checkbox label="Set as default filter settings" />
          </div> */}
        </Stack>
      </Panel>
      <Panel
        isLightDismiss
        isOpen={isOpenAttachment}
        onDismiss={dismissAttachmentPanel}
        closeButtonAriaLabel="Close"
        type={PanelType.smallFluid}
        className="upload-panel"
        layerProps={{ eventBubblingEnabled: true }}
        styles={{
          scrollableContent: { overflow: "visible" },
          content: { overflow: "visible" },
        }}
      >
        <FileUpload
          nomination={
            nominations.filter((i) => i.nominationNo === selectedNomination) &&
            nominations.filter((i) => i.nominationNo === selectedNomination)[0]
          }
          canUploadFile={props.isTruckUploadFileAllowed}
          modality={modality}
        />
      </Panel>
    </>
  );
};

export default connect(
  (state: State) => (state: State) => ({
    ...state.selectedTab,
    ...state.general,
  }),

  {
    ...LineHandlingStore.actionCreators,
    ...ProcessFlowConfigStore.actionCreators,
    ...SofViewStore.actionCreators,
    ...SelectedTabStore.actionCreators,
    ...GeneralStore.actionCreators,
  }
)(NominationListPage as any);
